import Button from "../../../core/button/button";
import "./matchingadtemplate.scss"

interface IAdTemplate {
    type: number
}

const MatchingAdTemplate = ({type}: IAdTemplate): JSX.Element => {
    const renderAdTemplateBody = (type: number) => {
        if (type === 0) {
            return (
                <div className="Ad-Template-Body text-center">
                    <h5 className="mt-3 pt-4 mb-2"> تخفیف ۲۰ درصدی روز مادر</h5>
                    <Button type={"secondary"} action={() => {
                    }} responsive={false}>برای خرید همین الان کلیک کن</Button>
                </div>
            );
        } else if (type === 1) {
            return (
                <div
                    className="Ad-Template-Body d-flex flex-xl-row flex-lg-column flex-column align-items-center justify-content-between">
                    <div className="d-flex align-items-center justify-content-center pt-2 gap-2">
                        <div className="Ad-Logo-Container">
                            <img src={require("../../../assets/images/Logo2.png")} alt="" className="img-fluid"/>
                        </div>
                        <span> تخفیف ۲۰ درصدی  عید نوروز</span>
                    </div>
                    <Button type={"primary"} action={() => {
                    }} responsive={true}>کلیک کنید</Button>
                </div>
            );
        } else if (type === 2) {
            return (
                <div
                    className="Ad-Template-Body">
                    <div className="border-bottom">
                        <h6>کیف مجلسی روشونی قرمز مدل Dior</h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="pt-2" style={{color: '#162198'}}> تخفیف ۲۰ درصدی  عید نوروز</span>
                        <Button type={"primary"} action={() => {
                        }} responsive={true}>کلیک کنید</Button>
                    </div>
                </div>
            );
        } else {
            return (
                <></>
            );
        }
    }
    return (
        <div className={`Ad-Template-${type}`}>
            <div className="Ad-Template-Header">
                <img src={require(`../../../assets/images/photos/AdTemplate${type + 1}.png`)} alt=""
                     className="img-fluid Ad-Template-Image"/>
            </div>
            {
                renderAdTemplateBody(type)
            }
        </div>
    );
}

export default MatchingAdTemplate;